import React, { Component } from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  Box
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Navigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

export default class Settingspage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      page: ""
    };
  }

  navigatePage = (page) => {
    this.setState({
      redirect: true,
      page: page
    });
  };
goBack = () => {
  window.history.back();
};
  render() {

const userid = localStorage.getItem("GBuserid");

    if (this.state.redirect) {
      return <Navigate to={this.state.page} />;
    }

    return (
      <div className="formdisplay">

 <div className="boxheading">
  <h2> <IconButton onClick={() => this.setState({ redirect: true, page: "/Dashboard" })}>
                         <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
          </IconButton>


    Settings</h2>
  
</div>
<List sx={{ py: 0 }}>

          <ListItemButton onClick={() => this.navigatePage("/Dashboard")}>
            <ListItemText primary="Dashboard" />
            <ChevronRightIcon />
          </ListItemButton>

  

        </List>
        <Typography variant="subtitle2" sx={{ mt: 2 }}>
          Account
        </Typography>

        <List>

          <ListItemButton onClick={() => this.navigatePage("/Profile")}>
            <ListItemText primary="Profile" />
            <ChevronRightIcon />
          </ListItemButton>

          <Divider />  

          <ListItemButton onClick={() => this.navigatePage("/Businessform")}>
            <ListItemText primary="Business Info" />
            <ChevronRightIcon />
          </ListItemButton>

          <Divider />
			<ListItemButton onClick={() => this.navigatePage("/Businesschangepassword")}>
            <ListItemText primary="Change Password" />
            <ChevronRightIcon />
          </ListItemButton>

          <Divider />
          <ListItemButton onClick={() => this.navigatePage("/Logout")}>
            <ListItemText primary="Logout" />
            <ChevronRightIcon />
          </ListItemButton>

        </List>

        <Typography variant="subtitle2" sx={{ mt: 4 }}>
          Document Settings
        </Typography>

        <List>

          <ListItemButton onClick={() => this.navigatePage("/QuotationSetting")}>
            <ListItemText primary="Quotation Setting" />
            <ChevronRightIcon />
          </ListItemButton>

          <Divider />

          <ListItemButton onClick={() => this.navigatePage("/PurchaseorderSetting")}>
            <ListItemText primary="Purchase Order Setting" />
            <ChevronRightIcon />
          </ListItemButton>
		  
		 {userid !== "1" && (
  <>
    <Divider />

    <ListItemButton onClick={() => this.navigatePage("/InvoiceSetting")}>
      <ListItemText primary="Invoice Setting" />
      <ChevronRightIcon />
    </ListItemButton>
  </>
)}

        </List>
		
		
		<Typography variant="subtitle2" sx={{ mt: 4 }}>
          Support
        </Typography>

        <List>

          <ListItemButton onClick={() => this.navigatePage("/Contactus")}>
            <ListItemText primary="Contact Us" />
            <ChevronRightIcon />
          </ListItemButton>

  

        </List>

      </div>
    );
  }
}